import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

export interface DialogUploadReceiptData {
  programType:number
  currentContractorType: number;
  currentContractorBusiness: string;
  currentContractorName: string;
  receiptType: string;
  receiptVendor: string;
  receiptDate: Date;
  attachmentName: string;
  uploadFileName: string;
  uploadFile: Blob;
}

@Component({
    selector: 'ebb-portal-dialog-upload-receipt',
    templateUrl: './dialog-upload-receipt.component.html',
    styles: [],
    standalone: false
})
export class DialogUploadReceiptComponent implements OnInit {
  @Input('title') title = 'Upload receipt';

  public displayFileName = 'No file selected.'
  public fileError = false;
  public fileSelected: any;
  public validFileSelected = false;
  public displayReceiptFields = false;
  public disableFileSave = true;

  public fileMaxSize = 15;
  readonly fileAcceptedTypes: string[] = [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/jpeg',
    'image/png'
  ];
  readonly imageAcceptedTypes: string[] = [
    'image/jpeg',
    'image/png'
  ];

  public formUploadReceipt: FormGroup;

  public showAttachmentCreatedDate = false;

  constructor(
    public readonly dialogRef: MatDialogRef<DialogUploadReceiptComponent>,
    private readonly fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogUploadReceiptData
  ) { }

  ngOnInit() {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.formUploadReceipt = this.fb.group({
      receiptType: ['', Validators.required],
      receiptVendor: ['', Validators.required],
      receiptDate: ['', Validators.required]
    });
    if (this.data.receiptDate) {
      this.formUploadReceipt.get('receiptType').setValue(this.data.receiptType);
      this.formUploadReceipt.get('receiptVendor').setValue(this.data.receiptVendor);
      this.formUploadReceipt.get('receiptDate').setValue(this.data.receiptDate);
      this.displayReceiptFields = true;
    }
  }

  public ebbFileInputChange(event: any) {
    this.disableFileSave = true;
    this.fileError = false;

    if (event.target.files.length > 0) {
      this.fileSelected = event.target.files[0];
      if ( !this.isValidFileType(this.fileSelected) )
      {
        this.fileError = true;
        this.displayFileName = `Only the following types of files can be uploaded: PDF, DOCX, JPG, PNG.`;
        return;
      }
      if ( !this.checkFileSize(this.fileSelected) )
      {
        this.fileError = true;
        this.displayFileName = `The file size must be less than ${this.fileMaxSize}MB`;
        return;
      }
      this.validFileSelected = true;
      this.data.uploadFile = this.fileSelected;
      this.data.uploadFileName = this.fileSelected.name;
      this.data.attachmentName = `${this.fileSelected.name}`;
      this.displayFileName = `File: ${this.fileSelected.name}`;
      this.displayReceiptFields = true;
      this.disableFileSave = false;
    } else {
      this.displayFileName = `Unable to load file`;
      console.warn(`File not loaded.`);
    }
  }

  public isValidFileType(file: Blob): boolean {
    let validType: boolean;
    validType = this.fileAcceptedTypes.indexOf(file.type) > -1;
    return validType;
  }

  public checkFileSize(file: Blob): boolean {
    let validSize = false;

    const fileSize: number = parseFloat((file.size / (1024 * 1024)).toFixed(3));

    ( (Math.round(fileSize*1000)) > (this.fileMaxSize*1000) ) ?
      validSize = false : validSize = true;

    return validSize;
  }

  public onCheckReceiptControlValidators(controlName: string): boolean {
    const retVal = (this.formUploadReceipt.get(controlName).errors
                      && (this.formUploadReceipt.get(controlName).dirty || this.formUploadReceipt.get(controlName).touched));
    return retVal;
  }

  public onChangeReceiptTypeEvent(value: string): void {
    if ((value && value.length > 0) && value === 'Contractor Invoice' &&
        parseInt(this.data.currentContractorType.toString(), 10) === 700000000) {
      if (this.data.currentContractorBusiness && this.data.currentContractorBusiness.length > 0) {
        this.formUploadReceipt.get('receiptVendor').setValue(this.data.currentContractorBusiness);
      } else {
        this.formUploadReceipt.get('receiptVendor').setValue(this.data.currentContractorName);
      }
    } else if ((value && value.length > 0) && value !== 'Contractor Invoice') {
      this.formUploadReceipt.get('receiptVendor').setValue('');
    }
  }

  public onClickSave(): void {
    this.data.receiptType = this.formUploadReceipt.get('receiptType').value;
    this.data.receiptVendor = this.formUploadReceipt.get('receiptVendor').value;
    const receiptDt : Date = new Date(this.formUploadReceipt.get('receiptDate').value);
    receiptDt.setHours(receiptDt.getHours()+7);
    this.data.receiptDate = receiptDt;
    this.dialogRef.close(this.data);
  }

  public onClickCancel(): void {
    this.dialogRef.close();
  }

}
